<template>
  <div class="list-header">
    <container>
      <div class="list-header__wrp">
        <div class="list-header__container">
          <div class="list-header__header">
            <div class="list-header__icon">
              <img :src="pageInfo.icon" alt="search movie" class="icon">
            </div>
            <div class="list-header__cnt">
              <h1 class="list-header__title" v-html="pageInfo.title"></h1>
              <div class="list-header__txt" v-html="pageInfo.text"></div>
            </div>
          </div>

          <div class="hero-search">
            <slot />
          </div>
        </div>
      </div>
    </container>
  </div>
</template>

<script>
export default {
  name: 'ListPageHeader',
  props: {
    pageInfo: Object
  }
}
</script>

<style lang="scss" scoped>
@import "../assets/scss/components/list-page-header";
</style>
